import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { COUNTIES } from "@/lib/constants";
import { toast } from "sonner";

export default function Auth() {
  const { login, register, googleLogin, formatErr } = useAuth() || {};
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", name: "", county: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        await login(form.email, form.password);
      } else {
        await register({ name: form.name, email: form.email, password: form.password, county: form.county });
      }
      toast.success("Bine ai venit!");
      nav("/profil");
    } catch (e) {
      toast.error(formatErr ? formatErr(e) : "Eroare la autentificare");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-auth" className="max-w-md mx-auto px-4 sm:px-6 py-16 md:py-24">
      <header className="text-center mb-8">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">{mode === "login" ? "Bine ai revenit" : "Cont nou"}</p>
        <h1 className="font-display text-4xl md:text-5xl text-[#F8F8F4]">
          {mode === "login" ? "Autentificare" : "Înregistrare"}
        </h1>
      </header>

      <button data-testid="google-login" onClick={googleLogin} className="w-full btn-ghost-light rounded-sm py-3 mb-4 text-sm uppercase tracking-widest font-medium">
        Continuă cu Google
      </button>

      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-white/10" /></div>
        <span className="relative bg-[#0A1020] px-3 text-xs text-[#6C7A9C] uppercase tracking-widest mx-auto block w-fit">sau email</span>
      </div>

      <form onSubmit={submit} className="space-y-3">
        {mode === "register" && (
          <>
            <input data-testid="auth-name" required placeholder="Nume complet" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full bg-[#131B2E] border border-white/10 rounded-sm px-4 py-3 text-sm" />
            <select data-testid="auth-county" value={form.county} onChange={e => setForm({ ...form, county: e.target.value })} className="w-full bg-[#131B2E] border border-white/10 rounded-sm px-4 py-3 text-sm">
              <option value="">— Județ (opțional) —</option>
              {COUNTIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </>
        )}
        <input data-testid="auth-email" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full bg-[#131B2E] border border-white/10 rounded-sm px-4 py-3 text-sm" />
        <input data-testid="auth-password" required type="password" minLength={6} placeholder="Parolă (min 6)" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="w-full bg-[#131B2E] border border-white/10 rounded-sm px-4 py-3 text-sm" />

        <button data-testid="auth-submit" disabled={loading} className="btn-gold rounded-sm py-4 w-full text-sm uppercase tracking-widest font-medium disabled:opacity-50">
          {loading ? "..." : mode === "login" ? "Intră în cont" : "Creează cont"}
        </button>
      </form>

      <p className="text-center text-sm text-[#A0AABF] mt-6">
        {mode === "login" ? "Nu ai cont? " : "Ai deja cont? "}
        <button data-testid="auth-toggle" onClick={() => setMode(mode === "login" ? "register" : "login")} className="text-[#D4A63D] hover:text-[#F2C053] underline">
          {mode === "login" ? "Înregistrează-te" : "Autentifică-te"}
        </button>
      </p>
    </div>
  );
}
